// extracted by mini-css-extract-plugin
export default {"verificationServiceDetailsDropdownMenu":"verification-service-details-dropdown-menu__verification-service-details-dropdown-menu__ncFCd"};